/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ItemCalculationFragmentDoc, WithDocumentItemTaskInfoFragmentDoc, WithItemPropertiesFragmentDoc, WithProductInfoFragmentDoc, WithDocumentItemCalculationFragmentDoc, DocumentItem_CalculationsFragmentDoc, WithProductFiltersInfoFragmentDoc, FieldsAffectedByAttributeExpressionsFragmentDoc, TreeItem__DocumentItemFragmentDoc, TreeItemTemplatePlaceholderFragmentDoc, WithDocumentItemInfoFragmentDoc, WithDocumentItemTreeInfoFragmentDoc, WithDocumentItemVisibilityInfoFragmentDoc, WithDocumentItemChangeOrderInfoFragmentDoc, WithDocumentItemAgreementInfoFragmentDoc, WithDocumentItemDecisionInfoFragmentDoc, ItemProductFieldsFragmentDoc } from '../../doc-items/Fragments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UseDownloadQuotePdfOptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UseDownloadQuotePdfOptionsQuery = { organisationContractingPdfs: { __typename: 'OrganisationContractingPdfsResult', contractingPdfs: Array<{ __typename: 'OrganisationContractingPdf', id: string, title: string }> }, organisationPdfGeneratorTemplates: { __typename: 'OrganisationPdfGeneratorTemplatesResult', templates: Array<{ __typename: 'PdfGeneratorTemplate', id: string, name: string }> }, organisationSexyQuotesConfig?: { __typename: 'SexyQuotesConfig', pdfTemplates: Array<{ __typename: 'SexyQuotesConfigPdfTemplate', label: string, pdfTemplateUrl: string, templateIds: Array<string> }> } | null };

export type UseDownloadQuotePdfOptions_QuoteFragment = { __typename: 'Quote', id: string, templateOriginQuoteId?: string | null, agreedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null };

export const UseDownloadQuotePdfOptions_QuoteFragmentDoc = gql`
    fragment UseDownloadQuotePdfOptions_Quote on Quote {
  id
  templateOriginQuoteId
  agreedCalculation {
    ...ItemCalculation
  }
}
    ${ItemCalculationFragmentDoc}`;
export const UseDownloadQuotePdfOptionsDocument = gql`
    query UseDownloadQuotePdfOptions {
  organisationContractingPdfs(filters: {enabled: true}) {
    ... on OrganisationContractingPdfsResult {
      contractingPdfs {
        id
        title
      }
    }
  }
  organisationPdfGeneratorTemplates {
    ... on OrganisationPdfGeneratorTemplatesResult {
      templates {
        id
        name
      }
    }
  }
  organisationSexyQuotesConfig {
    ... on SexyQuotesConfig {
      pdfTemplates {
        label
        pdfTemplateUrl
        templateIds
      }
    }
  }
}
    `;

/**
 * __useUseDownloadQuotePdfOptionsQuery__
 *
 * To run a query within a React component, call `useUseDownloadQuotePdfOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseDownloadQuotePdfOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseDownloadQuotePdfOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseDownloadQuotePdfOptionsQuery(baseOptions?: Apollo.QueryHookOptions<UseDownloadQuotePdfOptionsQuery, UseDownloadQuotePdfOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseDownloadQuotePdfOptionsQuery, UseDownloadQuotePdfOptionsQueryVariables>(UseDownloadQuotePdfOptionsDocument, options);
      }
export function useUseDownloadQuotePdfOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseDownloadQuotePdfOptionsQuery, UseDownloadQuotePdfOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseDownloadQuotePdfOptionsQuery, UseDownloadQuotePdfOptionsQueryVariables>(UseDownloadQuotePdfOptionsDocument, options);
        }
export function useUseDownloadQuotePdfOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseDownloadQuotePdfOptionsQuery, UseDownloadQuotePdfOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseDownloadQuotePdfOptionsQuery, UseDownloadQuotePdfOptionsQueryVariables>(UseDownloadQuotePdfOptionsDocument, options);
        }
export type UseDownloadQuotePdfOptionsQueryHookResult = ReturnType<typeof useUseDownloadQuotePdfOptionsQuery>;
export type UseDownloadQuotePdfOptionsLazyQueryHookResult = ReturnType<typeof useUseDownloadQuotePdfOptionsLazyQuery>;
export type UseDownloadQuotePdfOptionsSuspenseQueryHookResult = ReturnType<typeof useUseDownloadQuotePdfOptionsSuspenseQuery>;
export type UseDownloadQuotePdfOptionsQueryResult = Apollo.QueryResult<UseDownloadQuotePdfOptionsQuery, UseDownloadQuotePdfOptionsQueryVariables>;